import { render } from "./KPIDeleteModal.vue?vue&type=template&id=3010d674"
import script from "./KPIDeleteModal.vue?vue&type=script&lang=js"
export * from "./KPIDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__